import React from "react";

type props = {
  itemRemarks: string[];
};

const ItemRemarks = (props: props) => {
  const { itemRemarks } = props;
  return (
    <div>
      {itemRemarks?.map((item: any, i: any) => {
        let newRemark = item != null ? item.replaceAll("\n", "<br/>") : "";
        return (
          <div
            key={i}
            className="mb-4"
            dangerouslySetInnerHTML={{ __html: newRemark }}
          ></div>
        );
      })}
    </div>
  );
};

export default ItemRemarks;
